import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Atm from "../../Assests/Atm.png"
export default function ProductShowcase() {
  const slides = [
    {
      img: Atm,
      title: "PoS Terminals",
      desc: "Zufinex's PoS terminal is a smart, all-in-one device designed to simplify in-person transactions for businesses across India.",
      button: "View Details",
    },
    {
      img: Atm,
      title: "Voice Payments",
      desc: "Empower your business with hands-free transactions using our secure voice payment solutions.",
      button: "Learn More",
    },
    {
      img: Atm,
      title: "Business Analytics",
      desc: "Get real-time insights into your sales, customers, and growth trends with our analytics dashboard.",
      button: "Explore Now",
    },
  ];

  return (
    <Box sx={{ py: 8, px: 4, backgroundColor: "#fff" }}>
      <Typography
        variant="h5"
        fontWeight="bold"
        textAlign="center"
        mb={1}
      >
        From Startup to Scale-Up <br /> We’ve Got You
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        mb={5}
      >
        Whether you’re just launching or scaling up, our tools grow with you.
      </Typography>

      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        spaceBetween={24}
        slidesPerView={1}
        loop
        style={{ width: '100%', padding: '0 16px' }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                gap: 4,
                maxWidth: '1200px',
                margin: '0 auto',
                width: '100%',
                padding: '0 16px',
              }}
            >
              {/* Left Side Image */}
              <Box
                component="img"
                src={slide.img}
                alt={slide.title}
                sx={{
                  width: { xs: "100%", md: "50%" },
                  maxWidth: '500px',
                  borderRadius: 3,
                  objectFit: "contain",
                  flexShrink: 0
                }}
              />

              {/* Right Side Text */}
              <Box sx={{ 
                  width: { xs: "100%", md: "45%" },
                  maxWidth: '600px',
                  padding: { xs: '16px 0', md: '0 16px' }
                }}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  gutterBottom
                  textAlign={{ xs: "center", md: "left" }}
                >
                  {slide.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  mb={2}
                  textAlign={{ xs: "center", md: "left" }}
                >
                  {slide.desc}
                </Typography>
                <Box textAlign={{ xs: "center", md: "left" }}>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#10B981",
                      borderRadius: "4px",
                      px: 3,
                      height: "48px",
                      width: "128px",
                      "&:hover": { backgroundColor: "#009973" },
                    }}
                  >
                    {slide.button}
                  </Button>
                </Box>
              </Box>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
}
